import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import AddUnit from "../../core/modals/inventory/addunit";
import EditUnit from "../../core/modals/inventory/editunit";
import Swal from "sweetalert2";
import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
// import Select from "react-select";
// import { DatePicker } from "antd";
import withReactContent from "sweetalert2-react-content";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { setToogleHeader, setunit_data } from "../../core/redux/action";
import Axios from "axios";
import { API_BASE_URL, DEL_UNITS, GET_UNITS } from "../../Config";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import { getUserPermissions } from "../../UserPermissions";
import SpinLoader from "../loader/SpinLoader";


export const Units = () => {

  const [userDataSession, setUserDataSession] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
      const userDataString = sessionStorage.getItem("userData");
      if (userDataString) {
          const userData = JSON.parse(userDataString);
          setUserDataSession(userData);
      } else {
        navigate('/');
          console.log("User data not found in sessionStorage");
      }
  }, []);

  const [permissions, setPermissions] = useState({
    isRead: 'd-none',
    isWrite: 'd-none',
    isDelete: 'd-none',
    isExport: 'd-none'
  });

  useEffect(() => {
    const perms = getUserPermissions("Units");
    setPermissions(perms);
  }, []);

  const dataSource = useSelector((state) => state.unit_data);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  // const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_UNITS}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            dispatch(setunit_data(response.data.ResultData));
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [editUnitObj, setEditUnitObj] = useState([]);
  const showEditModal = (unitObj) => {
    setEditUnitObj(unitObj);
  };

  const columns = [

    {
      title: "S.No",
      render: (text, record, index) => index + 1,
    },

    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.length - b.Name.length,
    },
    {
      title: "Code",
      dataIndex: "Code",
      sorter: (a, b) => a.Code.length - b.Code.length,
    },

    // {
    //   title: "Createdon",
    //   dataIndex: "CreatedOn",
    //   sorter: (a, b) => {
    //     const dateA = new Date(a.CreatedOn);
    //     const dateB = new Date(b.CreatedOn);
    //     return dateA.getTime() - dateB.getTime();
    //   },
    //   render: (dateString) => {
    //     const date = new Date(dateString);
    //     const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
    //       date.getMonth() + 1
    //     )
    //       .toString()
    //       .padStart(2, "0")}-${date.getFullYear()}`;

    //     return formattedDate;
    //   },
    // },

    {
      title: 'Status',
      dataIndex: 'IsActive',
      render: (IsActive) => (
          <span className={`badge bg-outline-${IsActive === true ? 'success' : 'danger'}`}>
              {IsActive === true ? 'Active' : 'Inactive'}
          </span>
      ),
      sorter: (a, b) => (a.IsActive ? 1 : -1) - (b.IsActive ? 1 : -1),
  },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className={`me-2 p-2 ${permissions.isWrite}`}
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightUnitEdit"
              aria-controls="offcanvasRightUnitEdit"
              onClick={() => showEditModal(record)}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link 
              className={`confirm-text p-2 ${permissions.isDelete}`}
              to="#"
            >
              <i
                data-feather="trash-2"
                className="feather-trash-2"
                onClick={() => showConfirmationAlert(record.Id)}
              ></i>
            </Link>
          </div>
        </td>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (unitId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Make a request to delete the unit
        deleteUnit(unitId);
      }
    });
  };

  const deleteUnit = (unitId) => {
    const requestData = { Id: unitId, UpdatedBy: userDataSession.UserId };

    Axios.post(`${API_BASE_URL}${DEL_UNITS}`, requestData)
      .then((response) => {
        if (response.data.ResultData[0].Status == 'Success') {
          // Show success message
          MySwal.fire({
            title: "Deleted!",
            text: "Unit has been deleted.",
            icon: "success",
            confirmButtonColor: "#00ff00",
          }).then(() => {
            // Reload the page after the user clicks "OK"
            window.location.reload();
          });
          // Optionally, you can update the unit list after deletion
        } else {
          // Show error message
          MySwal.fire({
            title: "Error",
            text: "Failed to delete unit.",
            icon: "error",
            confirmButtonColor: "#00ff00",
          });
        }
      })
      .catch((error) => {
        console.error("Error deleting unit:", error);
        // Show error message
        MySwal.fire({
          title: "Error",
          text: "Failed to delete unit.",
          icon: "error",
          confirmButtonColor: "#00ff00",
        });
      });
  };

  const handleDownloadExcel = () => {
    if (data.length === 0) {
        return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = dataSource?.map((item) => ({
        'Category Name': item.Name,
        'Category Code': item.Code,
        'Created Date': item.CreatedOn,
        'Dscription': item.Description,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'UnitsData');

    // Save the workbook to a file
    XLSX.writeFile(wb, 'UnitsData.xlsx');
};

  const generatePDF = () => {
      const doc = new jsPDF();

      // Set properties for PDF
      doc.setProperties({
          title: 'Attendance Report',
          author: 'Your Name',
          creator: 'Your Application'
      });

      // Add data to PDF
      const tableData = []; // Your data array here

      // Add a header row
      const headers = ['Name', 'Code', 'Description', 'Created Date'];
      tableData.push(headers);

      // Add rows
      dataSource.forEach(item => {
          const row = [];
          row.push(item.Name, item.Code, item.Description, item.CreatedOn);
          tableData.push(row);
      });

      // Generate table
      doc.autoTable({
          head: [headers],
          body: tableData.slice(1),
      });

      // Save the PDF
      doc.save('UnitsData.pdf');
  };

  const handleReload = (e) => {
    e.preventDefault();
    window.location.reload();
  };


  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Units</h4>
                <h6>Manage your units</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li className={` ${permissions.isExport}`}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li className={` ${permissions.isExport}`}>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={handleDownloadExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={handleReload}>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              <a
                to="#"
                className={`btn btn-added ${permissions.isRead}`}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightUnitAdd"
                aria-controls="offcanvasRightUnitAdd"
              >
                <PlusCircle className="me-2" />
                Add 
              </a>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
                
              </div>
   
              <div className="table-responsive">
                {loading ? (
                  <SpinLoader/>
                  // <div className="loader m-auto"></div>
                ) : (
                  <Table columns={columns} dataSource={dataSource} />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <AddUnit />
        <EditUnit unitObj={editUnitObj} />
      </div>
    </>
  );
};
